<template>
  <div class="servicepopup">
    <el-dialog :visible.sync="servicepopupvisible" :show-close="false">
      <div class="content" :class="`content_${servicepopupType}`">
        <div class="service-code"></div>
        <div class="btn" @click="servicepopupvisible = false"></div>
        <img
          src="@/assets/image/close2.webp"
          class="close"
          alt=""
          srcset=""
          @click="servicepopupvisible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState("app", ["servicepopupType"]),
    servicepopupvisible: {
      get() {
        return this.$store.state.app.servicepopupvisible;
      },
      set(visible) {
        this.setServicepopupvisible({ visible });
      },
    },
  },
  methods: {
    ...mapActions("app", ["setServicepopupvisible"]),
  },
};
</script>

<style scoped lang="scss">
.servicepopup {
  @include popupNo;
  &::v-deep .el-dialog {
    border-radius: 20px;
  }
}
.content {
  width: 460px;
  height: 526px;
  background-image: url(~@/static/codePopup.webp);
  background-size: 100% auto;
  position: relative;
  .service-code {
    position: absolute;
    width: 175px;
    height: 175px;
    left: 50%;
    transform: translate(-50%);
    top: 230px;
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -48px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
.content_2 {
  height: 505px;
  background-image: url(~@/assets/image/service/100.webp);
  .service-code {
    display: none;
  }
  .btn {
    width: 300px;
    height: 58px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
.content_3 {
  height: 575px;
  background-image: url(~@/assets/image/service/30.webp);
  position: relative;
  .service-code {
    display: none;
  }
  .btn {
    width: 300px;
    height: 58px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
</style>
